(function () {
  if (window.DrboProductDetails) return;

  var patterns = {
    specifications: /^(?:technische (?:daten|spezifikationen|übersicht)|technical (?:specifications|data|overview)|set specifications)(?:\b|[:：])/i,
    faq: /^(?:faq|häufige fragen|häufig gestellte fragen|frequently asked questions|frequent questions|questions to consider before choosing)(?:\b|[:：])/i,
    contents: /^(?:lieferumfang|scope of delivery|included items|what['’]s included|not included)(?:\b|[:：])/i,
    warnings: /^(?:wichtige hinweise|hinweise|important (?:information|notes))(?:\b|[:：])/i
  };

  function textOf(element) {
    return (element.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function clean(fragment) {
    fragment.querySelectorAll('script,style,iframe,form,input,button,object,embed').forEach(function (element) { element.remove(); });
    fragment.querySelectorAll('*').forEach(function (element) {
      Array.from(element.attributes).forEach(function (attribute) {
        if (/^(?:on|id$|style$)/i.test(attribute.name) || /^(?:javascript|data):/i.test(attribute.value.trim())) element.removeAttribute(attribute.name);
      });
    });
    return fragment;
  }

  function extract(source) {
    var headings = Array.from(source.querySelectorAll('h1,h2,h3,h4,h5,h6'));
    var sections = [];
    var consumed = -1;
    headings.forEach(function (heading, index) {
      if (index <= consumed) return;
      var label = textOf(heading);
      var kind = Object.keys(patterns).find(function (key) { return patterns[key].test(label); });
      if (!kind) return;
      var level = Number(heading.tagName.slice(1));
      var endIndex = index + 1;
      while (endIndex < headings.length && Number(headings[endIndex].tagName.slice(1)) > level) endIndex++;
      var range = document.createRange();
      range.setStartAfter(heading);
      if (headings[endIndex]) range.setEndBefore(headings[endIndex]);
      else range.setEnd(source, source.childNodes.length);
      var content = clean(range.cloneContents());
      if (!textOf(content)) return;
      sections.push({ kind: kind, label: label, content: content });
      consumed = endIndex - 1;
    });
    return sections;
  }

  function mount(root) {
    if (root.dataset.detailsReady) return;
    var template = root.querySelector('[data-product-details-source]');
    var output = root.querySelector('[data-product-details-output]');
    if (!template || !output) return;
    var sections = extract(template.content);
    if (!sections.some(function (section) { return section.kind === 'specifications'; })) return;

    template.content.querySelectorAll('.at-versand-hinweis').forEach(function (notice) {
      var fragment = document.createDocumentFragment();
      fragment.appendChild(notice.cloneNode(true));
      var warning = document.createElement('div');
      warning.className = 'drbo-product-details__notice';
      warning.appendChild(clean(fragment));
      output.appendChild(warning);
    });

    sections.forEach(function (section, index) {
      var disclosure = document.createElement('details');
      disclosure.className = 'drbo-product-details__section';
      disclosure.open = section.kind === 'specifications' || section.kind === 'warnings';
      disclosure.id = root.closest('[data-section-id]').id + '-product-' + section.kind + '-' + index;
      disclosure.dataset.productDetailKind = section.kind;
      if (section.kind === 'specifications') disclosure.setAttribute('data-current-product-specifications', '');
      if (section.kind === 'faq') disclosure.setAttribute('data-current-product-faq', '');
      var summary = document.createElement('summary');
      summary.textContent = section.label;
      var body = document.createElement('div');
      body.className = 'drbo-product-details__body';
      body.appendChild(section.content);
      body.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(function (heading) {
        var replacement = document.createElement('h3');
        replacement.append.apply(replacement, Array.from(heading.childNodes));
        heading.replaceWith(replacement);
      });
      body.querySelectorAll('table').forEach(function (table) {
        var scroller = document.createElement('div');
        scroller.className = 'drbo-product-details__table';
        scroller.tabIndex = 0;
        scroller.setAttribute('role', 'region');
        scroller.setAttribute('aria-label', section.label);
        table.before(scroller);
        scroller.appendChild(table);
      });
      disclosure.append(summary, body);
      output.appendChild(disclosure);
    });

    var comparison = root.parentElement.querySelector('[data-product-series-comparison]');
    if (comparison) {
      var disclosure = document.createElement('details');
      disclosure.className = 'drbo-product-details__comparison';
      var summary = document.createElement('summary');
      summary.textContent = root.dataset.comparisonLabel;
      comparison.before(disclosure);
      disclosure.append(summary, comparison);
    }
    output.hidden = false;
    root.parentElement.classList.add('drbo-product-details-container');
    root.dataset.detailsReady = 'true';
    document.dispatchEvent(new Event('drbo:product-details:ready'));
  }

  function mountAll() {
    document.querySelectorAll('[data-drbo-product-details]').forEach(mount);
  }

  window.DrboProductDetails = { extract: extract, mountAll: mountAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll, { once: true });
  else mountAll();
  document.addEventListener('shopify:section:load', mountAll);
}());
